import { AppRouter } from '@infuse/ui/router';
import { notifyNotAllowed, notifyNotFound } from './notify-not-found';

export const redirectAndShowNotification = (timeout: number): void => {
  const routeChain = AppRouter.currentRoute.value.matched;
  AppRouter.push(routeChain[findFirstParentRouteIndexWithoutRedirect()].path).then(() => notifyNotFound(timeout));
};

export const redirectAndShowNotAllowedNotification = (timeout: number): void => {
  const routeChain = AppRouter.currentRoute.value.matched;
  AppRouter.push(routeChain[findFirstParentRouteIndexWithoutRedirect()].path).then(() => notifyNotAllowed(timeout));
};

export const findFirstParentRouteIndexWithoutRedirect = (): number => {
  let redirectIndex = 0;
  for (let i = AppRouter.currentRoute.value.matched.length - 1; i >= 0; i--) {
    const route = AppRouter.currentRoute.value.matched[i];

    if (route.children.length && !route.children.some((c) => c.redirect)) {
      redirectIndex = i;
      break;
    }
  }

  return redirectIndex;
};
